// src/utils/slug.js
export function createSlug(title) {
  console.log("title", title);
  if (!title) return '';

  return title
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')        // spaces → -
    .replace(/[^\w-]+/g, '')     // remove non-word chars
    .replace(/--+/g, '-')        // multiple - → single -
    .replace(/^-+/, '')          // trim leading -
    .replace(/-+$/, '');         // trim trailing -
}